import React from 'react'
import { SvgIcon } from '@mui/material'

export const VerifiedAccount = props => (
  <SvgIcon viewBox="0 0 20 21" {...props}>
    <path fill="#fff" d="M5 5.5h10v10H5z" />
    <path
      d="m19.17 10.5-2.04-2.32.29-3.08-3.01-.68-1.58-2.67L10 2.97 7.17 1.75 5.59 4.41l-3 .67.28 3.09L.83 10.5l2.04 2.32-.29 3.09 3.01.68 1.58 2.66L10 18.02l2.83 1.22 1.58-2.66 3-.68-.28-3.08 2.04-2.32ZM8.4 14.43l-3.17-3.17 1.23-1.23 1.94 1.94 4.87-4.9 1.24 1.24-6.11 6.12Z"
      fill="currentColor"
    />
  </SvgIcon>
)
